export default __webpack_public_path__ + "static/media/superLike.4dfa2f87.svg";